import React, { useState } from 'react';
import { Button } from 'antd';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import { useAddUrlAnalysisProcessBatchMutation, useAddDomainAnalysisProcessMutation } from '../process/service';
import './FailedChecks.less';


type Props = {
    selectedWebsiteGuid: string;
};


export default function RecheckAllUrlsButton({ selectedWebsiteGuid }: Props) {
    const { isRunningBatchAnalysis, isLoadingRunningProcesses } = useBatchUrlAnalysisProcessesPolling(selectedWebsiteGuid);
    const [isButtonLoading, setIsButtonLoading] = useState(isRunningBatchAnalysis);
    const [addDomainAnalysisProcess, { isLoading: isAddingDomainAnalysisProcess }] = useAddDomainAnalysisProcessMutation();
    const [addBatchUrlAnalysisProcesses, { isLoading: isAddingBatchUrlAnalysisProcesses }] = useAddUrlAnalysisProcessBatchMutation();
    const handleAddUrlAnalysisProcesses = async () => {
        if (isRunningBatchAnalysis) {
            return;
        }

        if (selectedWebsiteGuid) {
            setIsButtonLoading(true);
            await addDomainAnalysisProcess({ w_guid: selectedWebsiteGuid }).unwrap();
            await addBatchUrlAnalysisProcesses({ w_guid: selectedWebsiteGuid }).unwrap();
        }
    };

    const isSelectedWebsiteIndexEntry = selectedWebsiteGuid !== null;
    const isPreparingAnalysis = isLoadingRunningProcesses || isAddingDomainAnalysisProcess || isAddingBatchUrlAnalysisProcesses;
    const isButtonDisabled = !isButtonLoading && (!isSelectedWebsiteIndexEntry || isPreparingAnalysis);

    return (
        <Button
            className="deep-analysis-small-button"
            size="small"
            disabled={isButtonDisabled}
            loading={isButtonLoading}
            onClick={handleAddUrlAnalysisProcesses}
            icon={"sync"}
        >
            Refresh analysis
        </Button>
    );
}
